import { Logo } from "./Logo";

// Während die Anmeldung geprüft wird: das Zeichen mit ruhigem Puls statt
// eines Textes. Der Text bleibt für Screenreader erhalten.
export function LoadingScreen(): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center bg-app" role="status" aria-live="polite">
      <div className="relative flex h-16 w-16 items-center justify-center">
        <span className="absolute inset-0 animate-ping rounded-full bg-brand-primary/15 [animation-duration:1.8s]" aria-hidden="true" />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-2xl border border-default bg-card text-primary shadow-md animate-pulse">
          <Logo size={34} />
        </span>
      </div>
      <span className="sr-only">Lade …</span>
    </div>
  );
}
